import _ from "lodash";
import AppNavMobile from "./AppNavMobile";
import AppNavItem from "./AppNavItem";
import AppNavManage from "./AppNavManage";
import AppNavObjects from "components/AppNav/AppNavObjects";
import { useStores } from "store/useStore";
import { observer } from "mobx-react";
import AppNavMetrics from "components/AppNav/AppNavMetrics";
import AppNavRewards from "./AppNavRewards";
import { useCallback } from "react";

const navItemsFirst = [
  { label: "Home", path: "/dashboard" },
  { label: "Flows", path: "/flows" },
];
const navItemsLast = [
  { label: "Broadcasts", path: "/broadcasts", fullPageReload: true },
  { label: "Emails", path: "/emails" },
  { label: "Forms", path: "/forms" },
];
const mobileMidItems = [{ label: "People", path: "/segments" }];
/**
 * Main navigation for the app
 */
const AppNav = () => {
  const { customObjectsStore, uiStore, accountStore } = useStores();
  const schemas = customObjectsStore.schemas.current();

  const customObjectsItems = _.map(schemas, (schema) => ({
    label: schema.displayNamePlural,
    path: `/objects/${schema.name}`,
  }));

  const toggle = useCallback(() => uiStore.createRewardDialog.toggle(), [
    uiStore,
  ]);

  const mobileExtraItems = [
    { label: "Flow Metrics", path: "/metrics/flows" },
    { label: "Email Metrics", path: "/metrics/emails" },
    { label: "Tags", path: "/settings/tags" },
    { label: "Custom Fields", path: "/settings/custom-fields" },
    { label: "Events", path: "/events" },
    {
      label: "1,000 bonus",
      onClick: toggle,
    },
    { label: "Earn up to 50%", href: "https://encharge.io/affiliate-program" },
  ];

  const renderItem = (item: {
    label: string;
    path: string;
    fullPageReload?: boolean;
  }) => (
    <AppNavItem
      label={item.label}
      path={item.path}
      key={item.label}
      fullPageReload={item.fullPageReload}
    />
  );

  return (
    <>
      {/* Show full or mobile version */}
      <div className="d-none d-lg-flex">
        {_.map(navItemsFirst, renderItem)}
        <AppNavObjects schemas={schemas} />
        {_.map(navItemsLast, renderItem)}
        <AppNavMetrics />
        <AppNavManage />
        <AppNavRewards />
      </div>
      <div className="d-block d-lg-none">
        <AppNavMobile
          items={[
            ...navItemsFirst,
            ...mobileMidItems,
            ..._.filter(customObjectsItems, (item) => item.label !== "People"),
            ...navItemsLast,
            ...mobileExtraItems,
          ]}
        />
      </div>
    </>
  );
};

export default observer(AppNav);
